"use strict";

angular.module("vendor")
.controller("SalesRepresentativesEditController", function($scope, $stateParams, SalesRepresentativeService) {

    function fetchAll() {
        if ($stateParams.id) {
            var params = {
                "id": $stateParams.id
            };
            SalesRepresentativeService.get(params).$promise.then(
                function onSuccess(data) {
                    $scope.userVendor = data;
                    $scope.userVendorName = data.name;

                }
            );
        }
    }

    fetchAll();

});



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/sale-representative/sale-representative-edit.controller.js
// module id = 1001
// module chunks = 0